import React, { useState } from "react";
import ReactGA from "react-ga";

import { login } from "../store/actions/homeActions";


import { connect } from "react-redux";
import { compose } from "redux";

import { Link } from "react-router-dom";

import { Redirect } from 'react-router-dom';

import { languageService } from "./lang/Lang.js";

// On uae.sahra.ai (and dev-uae.sahra.ai), /login must redirect to /phone-login.
// ar.sahra.ai keeps both routes reachable.
const isUAESite = () => {
  if (typeof window === "undefined") return false;
  return /(^|\.)uae\.sahra\.ai$/i.test(window.location.hostname) ||
         /(^|\.)dev-uae\.sahra\.ai$/i.test(window.location.hostname);
};


function Login(props) {
  const { profile, loginFN, errore, loggedin } = props;
  const [username, setusername] = useState(null);
  const [pwd, setpwd] = useState(null);

  if (isUAESite()) return <Redirect to="/phone-login" />;


  const handleSubmit = (e) => {
    e.preventDefault();

    ReactGA.event({
      category: "User",
      action: "Logged",
    });


    loginFN(
      username || profile.username,
      pwd || profile.pwd
    );
  };


  return loggedin ? <Redirect to="/chat" /> : (
    <div className="container" style={{ marginTop: "60px" }}>
      <div className="columns" style={{ margin: 13, background: "white", borderRadius: "3px" }}>
        <div
          className="column"
          style={{
            color: "black",
            padding: "10px !important",
          }}
        >
          <form onSubmit={handleSubmit} style={{}}>
            <div style={{ height: "10px" }}></div>

            <p><b>{languageService.translate('login.t1')}:</b></p>
            <div style={{ height: "10px" }}></div>
            <div className="field">
              <p className="control has-icons-left">
                <input
                  required
                  className="input"
                  type="text"
                  placeholder={languageService.translate('login.t2')}
                  id="username"
                  name="username"
                  onChange={(v) => {
                    setusername(v.target.value);
                  }}
                  style={{ color: "#4b6385", fontSize: "1.2em" }}
                />
                <span className="icon is-small is-left">
                  <i className="fas fa-user"></i>
                </span>
              </p>
            </div>

            <div className="field">
              <p className="control has-icons-left">
                <input
                  required
                  className="input"
                  type="password"
                  placeholder={languageService.translate('login.t3')}
                  id="pwd"
                  name="pwd"
                  onChange={(v) => {
                    setpwd(v.target.value);
                  }}
                  defaultValue={profile.pwd}
                  style={{ color: "#4b6385", fontSize: "1.2em" }}
                />
                <span className="icon is-small is-left">
                  <i className="fas fa-key"></i>
                </span>
              </p>
            </div>








            <div className="field">
              <button
                style={{
                  padding: "10px 15px",
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  border: 0,
                  color: "#fff",
                  background: "#F35875",
                  borderRadius: "3px",
                }}
              >
                {languageService.translate('login.t4')}
              </button>
            </div>

            {errore ? <p style={{ color: "red" }}>{languageService.translate("reducer.t3")}</p> : null}
          </form>
          <div style={{ height: "20px" }}></div>

          <p>{languageService.translate('login.t5')} <Link to="/register" style={{ color: "#F35875" }}>{languageService.translate('login.t6')}.</Link> {languageService.translate('login.t7')} <Link to="/recovery" style={{ color: "#F35875" }}>{languageService.translate('login.t8')}</Link>.</p>




        </div>
      </div>
    </div>);

}

const mapStateToProps = (state) => {
  return {
    profile: state.home.profile,
    errore: state.home.errore,
    loggedin: state.home.loggedin,


  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loginFN: (username, pwd) =>
      dispatch(login(username, pwd)),

  };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(Login);
